import React from 'react';

import pictureLogo from '../../../images/logo.png';
import {useBreakpoint} from "../../../libs/breakpoint";
import Cookies from 'universal-cookie';
import backButton from "../../../libs/backButton";
import _ from "lodash";
import Icon from "../../components/Icon";
import "./Disclaimer.scss";

import imgDisclaimerDesktop from "./images/banner-disclamer.png"
import imgDisclaimerMobile from "./images/banner-disclamer-mobile.png"

import imgArrowDown from "./images/go-down.png";
import imgPicto14 from "./images/pictos-14.png";
import img1 from "./images/images-1.png";
import img2 from "./images/images-2.png";
import img3 from "./images/images-3.png";

import pictoFlame from "./images/flame.svg";
import picto12 from "./images/pictos-12.svg"
import {SpinLoader} from "../../components/Loader";



const cookies = new Cookies();

const Disclaimer = (props) => {
    const breakpoints = useBreakpoint();
    let source = localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_source`) || "";

    let isTool = _.get(props.isTool,'status') || false;
    let isToolInitialized = props.isToolInitialized || false;

    function godownContent(){
        let id = "content-down";
        if (document.getElementById(id)) {
            const element = document.getElementById(id);
            if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    function disclaim() {
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_fromdsiclaimer`, "1");
        cookies.set('DISCLAIMED', 'accepted',{expire:0});
        props.handleBlur();



        let isChrome = RegExp(/Chrome\/[0-9.]+ (?:Mobile )?Safari\/[0-9.]+$|CriOS|Googlebot/).test(window.navigator.userAgent);
        //permet de verifier si on affiche ou non la popunder
        if(!isTool && isChrome){
            return;
        }

        // Pour les langues non-FR on coupe la popunder chrome
        let enterButton = document.querySelector('.enter-website');
        if ( isChrome && (document.querySelector('html.translated-ltr') || (enterButton && enterButton.innerText !== 'ENTRER')) ) {
            return;
        }


        window.open( window.location.href, '_blank');
        backButton("popunder");
        let uriTool = breakpoints.md ? "https://tools.emstat.fr/voissa/pop-mobile.php" : "https://tools.emstat.fr/voissa/pop-desktop.php"
        if(!["", "voissa"].includes(source)){
            uriTool = `${uriTool}?adparameter2=${source}`
        }
        window.open(uriTool, "_self");
    }

    if(!props.hasAcceptedDisclaimer){
        backButton("popdisclaimer", {source});
    }
/*
    return props.hasAcceptedDisclaimer ? null : (
        <div id={"disclaimer"} >
            <div className={"container"}>
                <div className={"column website-infos"} onClick={(e) => e.stopPropagation()}>
                    <Title display={"display-1"} heading={"heading-2"}><img src={pictureLogo} alt={"logo Voissa"}/></Title>
                    <div className={"sub-title"}>
                        <div className={"pb-8"}><strong>Voissa</strong>, la première communauté <strong>exhib amateur
                            francophone</strong></div>
                        La référence <b>depuis 1999</b> avec plus d'un million de <u>photos sexy</u> et <u>vidéos porno
                        amateur</u>, des milliers de blogs et l'amour du sexe sans vulgarité.
                    </div>
                    <span className={"disclaimer-info"}>Pour accéder au contenu, je certifie être majeur.</span>
                    <div className={"btn-group"}>
                        <Button className={"enter-website"}
                                size={"medium"}
                                btnStyle={"primary-reverse"}
                                loading={!isToolInitialized}
                                onClick={() => isToolInitialized ? disclaim() : null}
                                icon={"18"}
                                iconSide={"right"}
                                content={"ENTRER"}/>

                    </div>
                </div>
            </div>
        </div>
    )*/


    return props.hasAcceptedDisclaimer ? null : (
        <div id="disclamer" className="disclamer" key={isToolInitialized}>
            <div className="disclamer-content">
                <div className="disclamer-content-banner">
                    <img className="banner-desktop" src={imgDisclaimerDesktop} alt="" />
                    <img className="banner-mobile" src={imgDisclaimerMobile} alt="" />
                </div>
                <div className="disclamer-content-info">

                    <div className="disclamer-content-info-logo">
                        <img src={pictureLogo} alt="" />
                        <p>Le plus bel espace de liberté</p>
                    </div>
                    <div className="disclamer-content-info-age">
                        <div className="disclamer-content-info-age-img"><Icon type={"18"} /> </div>

                        <p>Le contenu présent sur Voissa est <b>interdit aux mineurs.</b></p>
                        <p>Si vous n’avez pas 18 ans, votre entrée est totalement interdite</p>
                        {isToolInitialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta" >
                                <SpinLoader />
                            </span>
                        )}

                        <span className="disclamer-content-info-age-down" onClick={()=> godownContent()} >Descendez pour en savoir plus sur Voissa</span>
                        <span className="disclamer-content-info-age-downicon" onClick={()=> godownContent()} ><img src={imgArrowDown} alt="" /></span>
                    </div>


                    <div className="disclamer-content-info-section" id={"content-down"}>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={picto12} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img1} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Un vent de liberté</h1>
                            <p>Depuis 1999, Voissa offre à ses membres un lieu d’échange, de partage et d’amour, un lieu
                                de liberté où donner libre cours à ses désirs, se montrer et se rencontrer. Notre
                                communauté est animée depuis toujours par les principes fondamentaux d’ouverture, de
                                bienveillance et de respect.
                            </p>
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-content">
                            <h1>Le grand frisson (ou le petit)</h1>
                            <p>Commencer sur Voissa, c’est ouvrir un nouveau chapitre dans sa vie, faire le choix du
                                bien-être par l’épanouissement du corps.<br />Que ce soit pour se dévoiler ou simplement
                                pour venir voir, être membre de Voissa c’est s’ouvrir, à la mesure de ses envies, selon
                                son bon plaisir. Alors à vous de jouer !
                            </p>
                        </div>
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={pictoFlame} alt="" />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img2} alt="" />
                        </div>
                    </div>

                    <div className="disclamer-content-info-section">
                        <div className="disclamer-content-info-section-img">
                            <div className="disclamer-content-info-section-img-picto">
                                <img src={imgPicto14} alt="" style={{width :"43px", aspectRatio : 1, objectFit : "contain"}} />
                            </div>
                            <img className="disclamer-content-info-section-img-illu" src={img3} alt="" />
                        </div>
                        <div className="disclamer-content-info-section-content">
                            <h1>Un lieu safe</h1>
                            <p>L’anonymat et la sécurité sont inscrits dans l’ADN de Voissa, ils sont protégés au
                                quotidien par sa communauté et ses modérateurs. <br />
                                C’est ce qui lui vaut d’être le jardin secret pour des milliers de membres, un lieu où
                                il fait bon vivre l’expérience de la sensualité et de la séduction.
                            </p>
                        </div>
                    </div>
                    <div className="disclamer-content-info-age no-box">
                        {isToolInitialized ? (
                            <span className="disclamer-content-info-age-cta" onClick={() => disclaim()}>
                                <div className={"enter-website"}>ENTRER</div>
                                <span>(c'est gratuit !)</span>
                            </span>
                        ) : (
                            <span className="disclamer-content-info-age-cta" >
                                <SpinLoader />
                            </span>
                        )}

                    </div>
                </div>
            </div>

        </div>
    )
};

export default Disclaimer;